module.exports = __webpack_public_path__ + "img/zhifubao.29fd8d73.png";